export function randomCode(
  length: number,
  includeUppercase: boolean,
  includeLowercase: boolean,
  includeNumbers: boolean,
  excludeCharacters: string
) {
  let result = ''
  let characters = ''
  characters += includeUppercase ? 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' : ''
  characters += includeLowercase ? 'abcdefghijklmnopqrstuvwxyz' : ''
  characters += includeNumbers ? '0123456789' : ''
  const charactersLength = characters.length
  for (let i = 0; i < length; i++) {
    const random = characters.charAt(
      Math.floor(Math.random() * charactersLength)
    )
    if (excludeCharacters.includes(random)) {
      i--
    } else {
      result += random
    }
  }
  return result
}
